import { z } from 'zod';

export const NpsSurveyType = z.enum(['TRANSACTIONAL', 'RELATIONSHIP']);

export type NpsSurveyTypeT = z.infer<typeof NpsSurveyType>;
